import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import RouteGuard from './components/RouteGuard';
import RootEntry from './components/RootEntry';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PublicPage from './pages/PublicPage';
import PrivatePage from './pages/PrivatePage';
import RevenuePage from './pages/RevenuePage';
import AgcStoragePage from './pages/AgcStoragePage';
import SettlementPage from './pages/SettlementPage';
import RtPricePage from './pages/RtPricePage';
import DataUploadPage from './pages/DataUploadPage';
import WorkbenchPage from './pages/WorkbenchPage';
import InterProvincePage from './pages/InterProvincePage';
import InterProvincePnlPage from './pages/InterProvincePnlPage';
import StationsOverviewPage from './pages/StationsOverviewPage';
import TodoManagePage from './pages/TodoManagePage';
import AdminPage from './pages/AdminPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import MediumTermTradePage from './pages/MediumTermTradePage';
import MediumTermBacktestPage from './pages/MediumTermBacktestPage';
import OptimizationPage from './pages/OptimizationPage';
import StrategyOptimizerPage from './pages/StrategyOptimizerPage';
import StrategyGuidePage from './pages/StrategyGuidePage';
import WeatherBulletinPage from './pages/WeatherBulletinPage';
import WeatherForecastMapPage from './pages/WeatherForecastMapPage';
import TradingDiaryPage from './pages/TradingDiaryPage';
import DispatchSopPage from './pages/DispatchSopPage';

const CityCapacity3DPage = lazy(() => import('./pages/CityCapacity3DPage'));

declare global {
  interface Window {
    __OPS_MODE__?: boolean;
  }
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<RootEntry />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RouteGuard>
            <AppLayout />
          </RouteGuard>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/public" element={<PublicPage />} />
        <Route path="/inter-province" element={<InterProvincePage />} />
        <Route path="/inter-province-pnl" element={<InterProvincePnlPage />} />
        <Route path="/private" element={<PrivatePage />} />
        <Route path="/revenue" element={<RevenuePage />} />
        <Route path="/agc-storage" element={<AgcStoragePage />} />
        <Route path="/settlement" element={<SettlementPage />} />
        <Route path="/rt-price" element={<RtPricePage />} />
        <Route path="/upload" element={<DataUploadPage />} />
        <Route path="/workbench" element={<WorkbenchPage />} />
        <Route path="/trading-diary" element={<TradingDiaryPage />} />
        <Route path="/stations-overview" element={<StationsOverviewPage />} />
        <Route path="/todos" element={<TodoManagePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/medium-term-trade" element={<MediumTermTradePage />} />
        <Route path="/medium-term-backtest" element={<MediumTermBacktestPage />} />
        <Route path="/strategy-optimizer" element={<StrategyOptimizerPage />} />
        <Route path="/optimization" element={<StrategyGuidePage />} />
        <Route path="/optimization/historical" element={<OptimizationPage />} />
        <Route
          path="/city-capacity-3d"
          element={
            <Suspense fallback={<div className="route-loading">装机空间载入中</div>}>
              <CityCapacity3DPage />
            </Suspense>
          }
        />
        <Route path="/weather-bulletin" element={<WeatherBulletinPage />} />
        <Route path="/weather-forecast-map" element={<WeatherForecastMapPage />} />
        <Route path="/dispatch-sop" element={<DispatchSopPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
